import React, { PropsWithChildren, createContext, useReducer } from 'react';
import { setLocale, getLocale } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

export type Actions = {
  type: 'SET_CURRENT_LANGUAGE';
  payload: { language: string };
};

export type Dispatch = {
  changeLanguage: (language: string) => void;
};

export type State = {
  language: string;
};

export type UseLanguage = [{ language: string }, { setLanguage: (language: string) => void }];

export const defaultState = (): State => ({
  language: getLocale(),
});

export const LanguageContext = createContext<any>([]);

export const reducers = (state: State, action: Actions): State => {
  switch (action.type) {
    case 'SET_CURRENT_LANGUAGE': {
      const { language } = action.payload;
      return {
        language,
      };
    }
    default:
      return state;
  }
};

export const LanguageProvider: React.FunctionComponent<PropsWithChildren> = (props) => {
  const [state, dispatch] = useReducer<React.Reducer<State, Actions>>(reducers, defaultState());

  const setLanguage = (language: string) => {
    dispatch({ type: 'SET_CURRENT_LANGUAGE', payload: { language } });
    setLocale(language);
  };

  return (
    <LanguageContext.Provider
      value={[
        state,
        {
          setLanguage,
        },
      ]}
    >
      {props.children}
    </LanguageContext.Provider>
  );
};
export default LanguageProvider;
